import { h } from "@stencil/core";
import { TableDataCell } from "../table-data-cell/table-data-cell";
import { TableDataHeader } from "../table-data-header/table-data-header";
export class TableDataColumnSelection {
    constructor() {
        this.group = false;
    }
    /** make the render function public */
    async getColumnMethods() {
        return {
            renderCell: this.renderCell.bind(this),
            renderHeader: this.renderHeader.bind(this)
        };
    }
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    renderHeader(tableState) {
        const onChange = (event) => {
            const { checked } = event.target;
            if (checked) {
                tableState.selectedRows = tableState.sortedData.map((row) => row._uxTableInternalId);
            }
            else {
                tableState.selectedRows = [];
            }
        };
        /*
        const mixed =
            tableState.data &&
            tableState.selectedRows &&
            tableState.selectedRows.length < tableState.data.length &&
            tableState.selectedRows.length !== 0;

         */
        const checked = tableState.data && tableState.selectedRows && tableState.selectedRows.length === tableState.data.length;
        return (h(TableDataHeader, { group: this.group }, h("ux-checkbox", { onChange: onChange,
            //mixed={mixed}
            checked: checked })));
    }
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    renderCell(row, tableState) {
        const onChange = (event) => {
            const { checked } = event.target;
            if (checked) {
                tableState.selectedRows = [...tableState.selectedRows, row._uxTableInternalId];
            }
            else {
                tableState.selectedRows = tableState.selectedRows.filter((rowId) => rowId !== row._uxTableInternalId);
            }
        };
        return (h(TableDataCell, null, h("ux-checkbox", { onChange: onChange, checked: tableState.selectedRows?.includes(row._uxTableInternalId) })));
    }
    static get is() { return "ux-table-data-column-selection"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-data-column-selection.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-data-column-selection.css"]
        };
    }
    static get properties() {
        return {
            "group": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "defines if the column should be a group"
                },
                "attribute": "group",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get methods() {
        return {
            "getColumnMethods": {
                "complexType": {
                    "signature": "() => Promise<{ renderCell: (row: SortedTableDataRowType, tableState: any) => any; renderHeader: (tableState: any) => any; }>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "SortedTableDataRowType": {
                            "location": "import",
                            "path": "../interface",
                            "id": "src/components/table-data/interface.ts::SortedTableDataRowType"
                        }
                    },
                    "return": "Promise<{ renderCell: (row: SortedTableDataRowType, tableState: any) => any; renderHeader: (tableState: any) => any; }>"
                },
                "docs": {
                    "text": "make the render function public",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=table-data-column-selection.js.map
